// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/market/v1/package.proto (package gdx.market.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { BoolValue, Duration, Message, proto3, protoInt64, StringValue } from "@bufbuild/protobuf";

/**
 * Enumerate possible features.
 *
 * @generated from enum gdx.market.v1.FeatureType
 */
export enum FeatureType {
  /**
   * @generated from enum value: FEATURE_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: FEATURE_TYPE_LIKES_LIMIT = 1;
   */
  LIKES_LIMIT = 1,

  /**
   * @generated from enum value: FEATURE_TYPE_MESSAGES_LIMIT = 2;
   */
  MESSAGES_LIMIT = 2,

  /**
   * @generated from enum value: FEATURE_TYPE_TOP_PROFILE = 3;
   */
  TOP_PROFILE = 3,

  /**
   * @generated from enum value: FEATURE_TYPE_ADVANCED_SEARCH = 4;
   */
  ADVANCED_SEARCH = 4,

  /**
   * @generated from enum value: FEATURE_TYPE_PREMIUM = 5 [deprecated = true];
   * @deprecated
   */
  PREMIUM = 5,

  /**
   * @generated from enum value: FEATURE_TYPE_USER_UNBLOCK = 6;
   */
  USER_UNBLOCK = 6,

  /**
   * @generated from enum value: FEATURE_TYPE_ALLOW_WHO_LIKED_YOU = 7 [deprecated = true];
   * @deprecated
   */
  ALLOW_WHO_LIKED_YOU = 7,

  /**
   * @generated from enum value: FEATURE_TYPE_ALLOW_DELETE_OWN_MESSAGE = 8;
   */
  ALLOW_DELETE_OWN_MESSAGE = 8,

  /**
   * @generated from enum value: FEATURE_TYPE_MESSAGE_SIZE = 9;
   */
  MESSAGE_SIZE = 9,

  /**
   * @generated from enum value: FEATURE_TYPE_PROFILE_DETAILS = 10;
   */
  PROFILE_DETAILS = 10,

  /**
   * @generated from enum value: FEATURE_TYPE_READ_ACTIVITY = 11;
   */
  READ_ACTIVITY = 11,

  /**
   * @generated from enum value: FEATURE_TYPE_GIFT = 12;
   */
  GIFT = 12,

  /**
   * @generated from enum value: FEATURE_TYPE_TOP_PROFILE_PLUS = 13;
   */
  TOP_PROFILE_PLUS = 13,

  /**
   * @generated from enum value: FEATURE_TYPE_ASTROLOGY_CHECK = 14;
   */
  ASTROLOGY_CHECK = 14,

  /**
   * @generated from enum value: FEATURE_TYPE_SEXUAL_CHECK = 15;
   */
  SEXUAL_CHECK = 15,

  /**
   * @generated from enum value: FEATURE_TYPE_POWER_LIKE = 16;
   */
  POWER_LIKE = 16,

  /**
   * @generated from enum value: FEATURE_TYPE_POWER_DONATION = 17;
   */
  POWER_DONATION = 17,

  /**
   * @generated from enum value: FEATURE_TYPE_PHOTO_REQUEST = 18;
   */
  PHOTO_REQUEST = 18,
}
// Retrieve enum metadata with: proto3.getEnumType(FeatureType)
proto3.util.setEnumType(FeatureType, "gdx.market.v1.FeatureType", [
  { no: 0, name: "FEATURE_TYPE_INVALID" },
  { no: 1, name: "FEATURE_TYPE_LIKES_LIMIT" },
  { no: 2, name: "FEATURE_TYPE_MESSAGES_LIMIT" },
  { no: 3, name: "FEATURE_TYPE_TOP_PROFILE" },
  { no: 4, name: "FEATURE_TYPE_ADVANCED_SEARCH" },
  { no: 5, name: "FEATURE_TYPE_PREMIUM" },
  { no: 6, name: "FEATURE_TYPE_USER_UNBLOCK" },
  { no: 7, name: "FEATURE_TYPE_ALLOW_WHO_LIKED_YOU" },
  { no: 8, name: "FEATURE_TYPE_ALLOW_DELETE_OWN_MESSAGE" },
  { no: 9, name: "FEATURE_TYPE_MESSAGE_SIZE" },
  { no: 10, name: "FEATURE_TYPE_PROFILE_DETAILS" },
  { no: 11, name: "FEATURE_TYPE_READ_ACTIVITY" },
  { no: 12, name: "FEATURE_TYPE_GIFT" },
  { no: 13, name: "FEATURE_TYPE_TOP_PROFILE_PLUS" },
  { no: 14, name: "FEATURE_TYPE_ASTROLOGY_CHECK" },
  { no: 15, name: "FEATURE_TYPE_SEXUAL_CHECK" },
  { no: 16, name: "FEATURE_TYPE_POWER_LIKE" },
  { no: 17, name: "FEATURE_TYPE_POWER_DONATION" },
  { no: 18, name: "FEATURE_TYPE_PHOTO_REQUEST" },
]);

/**
 * Enumerates possible package types.
 *
 * @generated from enum gdx.market.v1.PackageType
 */
export enum PackageType {
  /**
   * @generated from enum value: PACKAGE_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: PACKAGE_TYPE_SUBSCRIPTION = 1;
   */
  SUBSCRIPTION = 1,

  /**
   * @generated from enum value: PACKAGE_TYPE_CREDITS = 2;
   */
  CREDITS = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(PackageType)
proto3.util.setEnumType(PackageType, "gdx.market.v1.PackageType", [
  { no: 0, name: "PACKAGE_TYPE_INVALID" },
  { no: 1, name: "PACKAGE_TYPE_SUBSCRIPTION" },
  { no: 2, name: "PACKAGE_TYPE_CREDITS" },
]);

/**
 * Enumerates possible subscription tiers.
 *
 * @generated from enum gdx.market.v1.Tier
 */
export enum Tier {
  /**
   * @generated from enum value: TIER_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: TIER_FREE = 1;
   */
  FREE = 1,

  /**
   * @generated from enum value: TIER_PLUS = 2;
   */
  PLUS = 2,

  /**
   * @generated from enum value: TIER_PREMIUM = 3;
   */
  PREMIUM = 3,

  /**
   * @generated from enum value: TIER_GOLD = 4;
   */
  GOLD = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(Tier)
proto3.util.setEnumType(Tier, "gdx.market.v1.Tier", [
  { no: 0, name: "TIER_INVALID" },
  { no: 1, name: "TIER_FREE" },
  { no: 2, name: "TIER_PLUS" },
  { no: 3, name: "TIER_PREMIUM" },
  { no: 4, name: "TIER_GOLD" },
]);

/**
 * Describes purchasable package.
 *
 * @generated from message gdx.market.v1.Package
 */
export class Package extends Message<Package> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: repeated gdx.market.v1.Price prices = 19;
   */
  prices: Price[] = [];

  /**
   * @generated from field: repeated gdx.market.v1.Tax taxes = 20;
   */
  taxes: Tax[] = [];

  /**
   * @generated from field: gdx.market.v1.PackageType type = 5;
   */
  type = PackageType.INVALID;

  /**
   * @generated from field: bool active = 6;
   */
  active = false;

  /**
   * @generated from field: int32 order = 7;
   */
  order = 0;

  /**
   * @generated from field: bool is_popular = 8;
   */
  isPopular = false;

  /**
   * @generated from field: bool is_discount = 9;
   */
  isDiscount = false;

  /**
   * @generated from field: uint32 discount = 10;
   */
  discount = 0;

  /**
   * @generated from field: repeated string tags = 11;
   */
  tags: string[] = [];

  /**
   * @generated from field: bool is_free = 12;
   */
  isFree = false;

  /**
   * @generated from field: string label = 13;
   */
  label = "";

  /**
   * @generated from oneof gdx.market.v1.Package.options
   */
  options: {
    /**
     * @generated from field: gdx.market.v1.SubscriptionOptions subscription_options = 14;
     */
    value: SubscriptionOptions;
    case: "subscriptionOptions";
  } | {
    /**
     * @generated from field: gdx.market.v1.CreditsOptions credits_options = 15;
     */
    value: CreditsOptions;
    case: "creditsOptions";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<Package>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.market.v1.Package";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "prices", kind: "message", T: Price, repeated: true },
    { no: 20, name: "taxes", kind: "message", T: Tax, repeated: true },
    { no: 5, name: "type", kind: "enum", T: proto3.getEnumType(PackageType) },
    { no: 6, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "is_popular", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "is_discount", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "discount", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 11, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "is_free", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "subscription_options", kind: "message", T: SubscriptionOptions, oneof: "options" },
    { no: 15, name: "credits_options", kind: "message", T: CreditsOptions, oneof: "options" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Package {
    return new Package().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Package {
    return new Package().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Package {
    return new Package().fromJsonString(jsonString, options);
  }

  static equals(a: Package | PlainMessage<Package> | undefined, b: Package | PlainMessage<Package> | undefined): boolean {
    return proto3.util.equals(Package, a, b);
  }
}

/**
 * Subscription package options.
 *
 * @generated from message gdx.market.v1.SubscriptionOptions
 */
export class SubscriptionOptions extends Message<SubscriptionOptions> {
  /**
   * @generated from field: bool is_trial = 1;
   */
  isTrial = false;

  /**
   * @generated from field: google.protobuf.Duration duration = 2;
   */
  duration?: Duration;

  /**
   * @generated from field: string next_subscription = 3;
   */
  nextSubscription = "";

  /**
   * @generated from field: repeated gdx.market.v1.Feature features = 4;
   */
  features: Feature[] = [];

  /**
   * @generated from field: gdx.market.v1.Tier tier = 5;
   */
  tier = Tier.INVALID;

  /**
   * @generated from field: bool is_one_time = 6;
   */
  isOneTime = false;

  constructor(data?: PartialMessage<SubscriptionOptions>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.market.v1.SubscriptionOptions";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "is_trial", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "duration", kind: "message", T: Duration },
    { no: 3, name: "next_subscription", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "features", kind: "message", T: Feature, repeated: true },
    { no: 5, name: "tier", kind: "enum", T: proto3.getEnumType(Tier) },
    { no: 6, name: "is_one_time", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscriptionOptions {
    return new SubscriptionOptions().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscriptionOptions {
    return new SubscriptionOptions().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscriptionOptions {
    return new SubscriptionOptions().fromJsonString(jsonString, options);
  }

  static equals(a: SubscriptionOptions | PlainMessage<SubscriptionOptions> | undefined, b: SubscriptionOptions | PlainMessage<SubscriptionOptions> | undefined): boolean {
    return proto3.util.equals(SubscriptionOptions, a, b);
  }
}

/**
 * Credits package options.
 *
 * @generated from message gdx.market.v1.CreditsOptions
 */
export class CreditsOptions extends Message<CreditsOptions> {
  /**
   * @generated from field: uint64 amount = 1;
   */
  amount = protoInt64.zero;

  constructor(data?: PartialMessage<CreditsOptions>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.market.v1.CreditsOptions";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "amount", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditsOptions {
    return new CreditsOptions().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditsOptions {
    return new CreditsOptions().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditsOptions {
    return new CreditsOptions().fromJsonString(jsonString, options);
  }

  static equals(a: CreditsOptions | PlainMessage<CreditsOptions> | undefined, b: CreditsOptions | PlainMessage<CreditsOptions> | undefined): boolean {
    return proto3.util.equals(CreditsOptions, a, b);
  }
}

/**
 * Describes subscription feature model.
 *
 * @generated from message gdx.market.v1.Feature
 */
export class Feature extends Message<Feature> {
  /**
   * @generated from field: gdx.market.v1.FeatureType type = 1;
   */
  type = FeatureType.INVALID;

  /**
   * @generated from field: string options = 2;
   */
  options = "";

  constructor(data?: PartialMessage<Feature>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.market.v1.Feature";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(FeatureType) },
    { no: 2, name: "options", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Feature {
    return new Feature().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Feature {
    return new Feature().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Feature {
    return new Feature().fromJsonString(jsonString, options);
  }

  static equals(a: Feature | PlainMessage<Feature> | undefined, b: Feature | PlainMessage<Feature> | undefined): boolean {
    return proto3.util.equals(Feature, a, b);
  }
}

/**
 * Extra message text.
 *
 * @generated from message gdx.market.v1.ExtraMessageText
 */
export class ExtraMessageText extends Message<ExtraMessageText> {
  /**
   * @generated from field: string text = 1;
   */
  text = "";

  constructor(data?: PartialMessage<ExtraMessageText>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.market.v1.ExtraMessageText";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExtraMessageText {
    return new ExtraMessageText().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExtraMessageText {
    return new ExtraMessageText().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExtraMessageText {
    return new ExtraMessageText().fromJsonString(jsonString, options);
  }

  static equals(a: ExtraMessageText | PlainMessage<ExtraMessageText> | undefined, b: ExtraMessageText | PlainMessage<ExtraMessageText> | undefined): boolean {
    return proto3.util.equals(ExtraMessageText, a, b);
  }
}

/**
 * Extra Connection ID.
 *
 * @generated from message gdx.market.v1.ExtraConnectionId
 */
export class ExtraConnectionId extends Message<ExtraConnectionId> {
  /**
   * @generated from field: string connection_id = 1;
   */
  connectionId = "";

  constructor(data?: PartialMessage<ExtraConnectionId>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.market.v1.ExtraConnectionId";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExtraConnectionId {
    return new ExtraConnectionId().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExtraConnectionId {
    return new ExtraConnectionId().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExtraConnectionId {
    return new ExtraConnectionId().fromJsonString(jsonString, options);
  }

  static equals(a: ExtraConnectionId | PlainMessage<ExtraConnectionId> | undefined, b: ExtraConnectionId | PlainMessage<ExtraConnectionId> | undefined): boolean {
    return proto3.util.equals(ExtraConnectionId, a, b);
  }
}

/**
 * Extra Gift.
 *
 * @generated from message gdx.market.v1.ExtraGift
 */
export class ExtraGift extends Message<ExtraGift> {
  /**
   * @generated from field: string gift_id = 1;
   */
  giftId = "";

  /**
   * @generated from field: string message_id = 2;
   */
  messageId = "";

  /**
   * @generated from field: string connection_id = 3;
   */
  connectionId = "";

  constructor(data?: PartialMessage<ExtraGift>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.market.v1.ExtraGift";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gift_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "message_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExtraGift {
    return new ExtraGift().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExtraGift {
    return new ExtraGift().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExtraGift {
    return new ExtraGift().fromJsonString(jsonString, options);
  }

  static equals(a: ExtraGift | PlainMessage<ExtraGift> | undefined, b: ExtraGift | PlainMessage<ExtraGift> | undefined): boolean {
    return proto3.util.equals(ExtraGift, a, b);
  }
}

/**
 * Extra Partner ID.
 *
 * @generated from message gdx.market.v1.ExtraPartnerId
 */
export class ExtraPartnerId extends Message<ExtraPartnerId> {
  /**
   * @generated from field: string partner_id = 1;
   */
  partnerId = "";

  constructor(data?: PartialMessage<ExtraPartnerId>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.market.v1.ExtraPartnerId";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "partner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExtraPartnerId {
    return new ExtraPartnerId().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExtraPartnerId {
    return new ExtraPartnerId().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExtraPartnerId {
    return new ExtraPartnerId().fromJsonString(jsonString, options);
  }

  static equals(a: ExtraPartnerId | PlainMessage<ExtraPartnerId> | undefined, b: ExtraPartnerId | PlainMessage<ExtraPartnerId> | undefined): boolean {
    return proto3.util.equals(ExtraPartnerId, a, b);
  }
}

/**
 * Describes ListPackages filter.
 *
 * @generated from message gdx.market.v1.PackagesFilter
 */
export class PackagesFilter extends Message<PackagesFilter> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  /**
   * @generated from field: google.protobuf.StringValue title = 2;
   */
  title?: string;

  /**
   * @generated from field: google.protobuf.BoolValue active = 3;
   */
  active?: boolean;

  /**
   * @generated from field: repeated string include_tags = 5;
   */
  includeTags: string[] = [];

  /**
   * @generated from field: repeated string exclude_tags = 6;
   */
  excludeTags: string[] = [];

  /**
   * @generated from field: gdx.market.v1.PackageType type = 7;
   */
  type = PackageType.INVALID;

  constructor(data?: PartialMessage<PackagesFilter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.market.v1.PackagesFilter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "title", kind: "message", T: StringValue },
    { no: 3, name: "active", kind: "message", T: BoolValue },
    { no: 5, name: "include_tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "exclude_tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "type", kind: "enum", T: proto3.getEnumType(PackageType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PackagesFilter {
    return new PackagesFilter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PackagesFilter {
    return new PackagesFilter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PackagesFilter {
    return new PackagesFilter().fromJsonString(jsonString, options);
  }

  static equals(a: PackagesFilter | PlainMessage<PackagesFilter> | undefined, b: PackagesFilter | PlainMessage<PackagesFilter> | undefined): boolean {
    return proto3.util.equals(PackagesFilter, a, b);
  }
}

/**
 * Price DTO.
 *
 * @generated from message gdx.market.v1.Price
 */
export class Price extends Message<Price> {
  /**
   * Base price with taxes included.
   *
   * @generated from field: uint64 price = 1;
   */
  price = protoInt64.zero;

  /**
   * @generated from field: string currency = 2;
   */
  currency = "";

  constructor(data?: PartialMessage<Price>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.market.v1.Price";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "price", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Price {
    return new Price().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Price {
    return new Price().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Price {
    return new Price().fromJsonString(jsonString, options);
  }

  static equals(a: Price | PlainMessage<Price> | undefined, b: Price | PlainMessage<Price> | undefined): boolean {
    return proto3.util.equals(Price, a, b);
  }
}

/**
 * DTO to describe applied taxes.
 *
 * @generated from message gdx.market.v1.Tax
 */
export class Tax extends Message<Tax> {
  /**
   * @generated from field: uint32 tax_percent = 1;
   */
  taxPercent = 0;

  /**
   * @generated from field: string currency = 2;
   */
  currency = "";

  constructor(data?: PartialMessage<Tax>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.market.v1.Tax";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tax_percent", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Tax {
    return new Tax().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Tax {
    return new Tax().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Tax {
    return new Tax().fromJsonString(jsonString, options);
  }

  static equals(a: Tax | PlainMessage<Tax> | undefined, b: Tax | PlainMessage<Tax> | undefined): boolean {
    return proto3.util.equals(Tax, a, b);
  }
}

